module.exports = __webpack_public_path__ + "static/media/COTK1.b9920644.JPG";